import { Box, Typography, useTheme } from '@mui/material';

import CommonButton from '../CommonButton';
import { ResUnStakingListType } from '@/types';

const PortfolioUnStakedCard = ({
  item,
  handleOpenModal,
}: {
  item: ResUnStakingListType;
  handleOpenModal: (type: string) => void;
}) => {
  // theme
  const theme = useTheme();
  if (!item) {
    return;
  }

  return (
    <Box
      sx={{
        borderRadius: '20px',
        border: `0.5px solid ${theme.greyscale.lightgrey1}`,
        boxShadow: '0px 0px 4px 0px #00000026',
      }}
    >
      <Box
        sx={{
          margin: '24px 16px',
          background: theme.background.default,
          borderRadius: '10px',
          border: `0.5px solid ${theme.greyscale.grey1}`,
        }}
      >
        {/* <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px',
            borderBottom: `0.5px solid ${theme.greyscale.lightgrey2}`,
          }}
        >
          <Typography variant="body2" color={theme.greyscale.grey1}>
            No.
          </Typography>

          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
              {item.no}
            </Typography>
          </Box>
        </Box> */}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px',
            borderBottom: `0.5px solid ${theme.greyscale.lightgrey2}`,
          }}
        >
          <Typography variant="body2" color={theme.greyscale.grey1}>
            Stake Amount
          </Typography>

          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
              {item.usdt}{' '}
              <Typography display={'inline'} variant="body4" color={theme.greyscale.darkgrey2}>
                USD
              </Typography>
            </Typography>
          </Box>
        </Box>

        {/* <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px',
            borderBottom: `0.5px solid ${theme.greyscale.lightgrey2}`,
          }}
        >
          <Typography variant="body2" color={theme.greyscale.grey1}>
            APR
          </Typography>

          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
              {item.dailyInterestMultipliedPriceAndRate}
              {'%'}
            </Typography>
          </Box>
        </Box> */}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px',
          }}
        >
          <Typography variant="body2" color={theme.greyscale.grey1}>
            Reward Start
          </Typography>

          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
              {item.regDt}
            </Typography>
          </Box>
        </Box>

        {/* <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px',
            borderBottom: `0.5px solid ${theme.greyscale.lightgrey2}`,
          }}
        >
          <Typography variant="body2" color={theme.greyscale.grey1}>
            Reward End
          </Typography>

          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
              {item.end}
            </Typography>
          </Box>
        </Box> */}

        {/* <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px',
          }}
        >
          <Typography variant="body2" color={theme.greyscale.grey1}>
            Rewards
          </Typography>

          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
              {item.rewards.toLocaleString()}{' '}
              <Typography display={'inline'} variant="body4" color={theme.greyscale.darkgrey2}>
                USD
              </Typography>
            </Typography>
          </Box>
        </Box> */}
      </Box>

      <Box
        sx={{
          width: '100%',
          height: '0.5px',
          margin: '24px 0px',
          borderBottom: `0.5px solid ${theme.greyscale.lightgrey2}`,
        }}
      />

      <Box
        sx={{
          margin: '24px 16px',
        }}
      >
        <CommonButton
          sx={{
            borderRadius: '10px',
            padding: '12px 20px',
            width: '100%',
          }}
          handleClick={() => handleOpenModal(String(item.stakeIndex))}
          text="Unstake"
          color={theme.background.blue}
          bgColor={'#ffffff'}
          border={theme.background.blue}
          variant="body2"
        />
      </Box>
    </Box>
  );
};

export default PortfolioUnStakedCard;
